import React, {Component} from 'react';
import * as Products from '../../../libraries/Products.js';
import * as Discount from '../../../libraries/Discount.js';
import QuantityDiscount from './QuantityDiscount';

class Normal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  };

  render() {
    let variant = Products.getVariantByVariantID(this.props.data.variant_id,this.props.data.product_id);
    //let product = Products.get(this.props.data.product_id);
    //console.log( this.props.data );
    let compare_price = null;
    if( variant!==null ){
      //console.log(variant);
      compare_price = variant.compareAtPrice.amount ?? null;
      //console.log(compare_price);
      if( compare_price!==null ) compare_price = parseFloat( compare_price );
    }
    //console.log( this.props.data );

    let price = this.props.data.final_price;

    //console.log(this.props.data);
    //if( this.props.data.properties?._custom_discount ){
    if( this.props.data.properties?._type==="bag size" ){
      //price = this.props.data.total_discount;
      price = this.props.data.price/100*this.props.data.quantity;
    }
    else{
      let discount = Discount.get(this.props.data);
      //console.log(discount);

      /*
      if( discount.eligible ){
        price *= (100-discount.rate*100)/100;
      }
      */
      price = Products.itemTotal(this.props.data,discount);
      //console.log(discount);

      price = parseFloat( parseFloat(price/100).toFixed(2) );
    }
    

    return (
      <div className="price_container px-1">
        <React.Fragment>
          {(() => {
            if (compare_price!==null) {
              return (
                <span className="compare_at">${(compare_price*this.props.data.quantity).toFixed(2).replace(/[.,]00$/, "")}</span>
              )
            }
          })()}
          {(() => {
            if (this.props.data.final_price===0) {
              return (
                <span className="price">(Free)</span>
              )
            }
            else return <span className="price">${(price).toFixed(2).replace(/[.,]00$/, "")}</span>
          })()}
          <QuantityDiscount 
            data={this.props.data}
            properties={this.props.data.properties}
          />
        </React.Fragment>
      </div>
    )
  };
}
export default Normal;